module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "slide-fade"
    }
  }, [_c('span', [(_vm.loaded_sticky == 'true') ? _c('main', {
    staticClass: "col-xs-12 internaslider"
  }, [_c('ul', _vm._l((_vm.programas_sticky), function(programa) {
    return _c('li', [(programa.imagen_horizontal.sizes.hasOwnProperty('1440x446')) ? _c('img', {
      attrs: {
        "src": programa.imagen_horizontal.sizes['1440x446'],
        "alt": ""
      }
    }) : (programa.imgs.hasOwnProperty('1440x446')) ? _c('img', {
      attrs: {
        "src": programa.imgs['1440x446'],
        "alt": ""
      }
    }) : _c('img', {
      attrs: {
        "src": _vm.theme_url + '/html/assets/img/programacion-1.jpg',
        "alt": ""
      }
    })])
  }))]) : _vm._e(), _vm._v(" "), (_vm.loaded == 'true') ? _c('div', {
    staticClass: "col-xs-12 block programacion"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('h2', [_vm._v("PROGRAMACION")]), _vm._v(" "), _c('ul', {
    staticClass: "col-xs-12 filtro"
  }, [_c('li', {
    staticClass: "active"
  }, [_c('a', {
    attrs: {
      "mostrar": "todo",
      "href": "#"
    }
  }, [_vm._v("Todo")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#",
      "mostrar": "entresemana"
    }
  }, [_vm._v("LUNES A VIERNES")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#",
      "mostrar": "finde"
    }
  }, [_vm._v("FIN DE SEMANA")])])]), _vm._v(" "), _vm._l((_vm.programas), function(programa) {
    return _c('div', {
      class: 'col-xs-12 col-xs-6 col-md-3 progitem progitem' + programa.semana_finde
    }, [_c('div', {
      staticClass: "col-xs-12 npd progitem__wrap paused"
    }, [_c('router-link', {
      staticClass: "toint",
      attrs: {
        "to": {
          name: 'programa',
          params: {
            elprograma: programa.slug
          }
        }
      }
    }, [_c('figure', [(programa.better_featured_image != null) ? _c('img', {
      attrs: {
        "src": programa.better_featured_image.media_details.sizes['367x256'].source_url,
        "alt": ""
      }
    }) : _c('img', {
      attrs: {
        "src": 'http://via.placeholder.com/367x256/008AD2/dddddd?text=' + programa.title.rendered,
        "alt": ""
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "flex-centermid progitem__des"
    }, [_c('p', [_c('i', {
      staticClass: "icon time"
    }), _c('span', {
      domProps: {
        "innerHTML": _vm._s(programa.acf.horarios_texto)
      }
    })])])]), _vm._v(" "), _c('h3', {
      domProps: {
        "innerHTML": _vm._s(programa.title.rendered)
      }
    })]), _vm._v(" "), (programa.post_meta != 0) ? _c('button', {
      staticClass: "reflexiones__player flex-centermid btn",
      attrs: {
        "audio": programa.post_meta._enclosure_mp3
      }
    }, [_c('i', {
      staticClass: "icon play-mini-white"
    })]) : _vm._e()], 1)])
  })], 2)])]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3da4e364"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/programas.vue
// module id = 129
// module chunks = 0